import React from "react";
import FastTextInput from "components/FormElements/FastTextInput";

function TextMetaProperty(props) {
    return <FastTextInput name={props.name} />;
}

export default TextMetaProperty;

export const Property = TextMetaProperty;

export const Label = "Text Input";
